export class DadosPessoais {
  matricula: number;
  nome: string;
  vinculo: string;
  cargo: string;
  telefone: number;
  celular: number;
  cpf: number;
  dataNascimento: string;
}


export class PlanoSaude {
  id: number;
  descricao: string;
}

export class TipoSolicitacao {
  codigo: number;
  descricao: string;
}

export class TipoPlano {
  codigo: number;
  descricao: string;
}

export class TipoParentesco {
  codigo: number;
  descricao: string;
}

export class TipoStatus {
  codigo: number;
  descricao: string;
}

export class Setor {
  codigo: number;
  descricao: string;
}

export class Dependente {
  cpf: number;
  dataNascimento: Date;
  nomeDependente: string;
  numeDependente: number;
  parentesco: string;
  tipoParentescoId: number;
}

export class SalvarPessoa {
  tipoSolicitacao: number;
  flagDependente: boolean;
  idDependente: number | null;
  tipoPlanoSaude: number;
  nomePlanoSaude: string;
  idPlanoSaude: number;
  valorPlanoSaude: number;
  cpf: string;
  nome: string;
  tipoParentesco: number;
  dataNascimento: Date;
}

export class ListaDependente {
  id: number;
  descricao: string;
}

export class Pessoa {
  cpf: string;
  dataNascimento: string;
  id: number;
  nome: string;
  nomePlanoSaude: string;
  tipoDependente: boolean;
  tipoParentescoId: number;
  tipoPlanoId: number;
  tipoPlanoSaude: string;
  tipoSolicitacaoId: number;
  valor: number;
}

export class TipoAnexo {
  descricao: string
  id: number
}

export class GridPessoas {
  dependentes: Pessoa[];
  titular: Pessoa[];
}

export class PessoaPorCPF {
  cpf: number;
  dataNascimento: string;
  nomeDependente: string;
  numeDependente: number;
  parentesco: string;
  tipoParentescoId: number;
}

export class Solicitacao {
  cpf: string;
  dataEnvio: string;
  id: number;
  matricula: number;
  nome: string;
  quantidadeDependentes:number;
  status: string;
  valorTotal: string;
}

export class ListaSolicitacoes {
  content: Solicitacao[]
  empty: boolean
  first: boolean
  last: boolean
  number: number
  numberOfElements: 1
  pageable: {sort: {empty: boolean, sorted: boolean, unsorted: boolean}, offset: number, pageNumber: number, pageSize: number, paged: boolean, unpaged: boolean}
  size: number
  sort: {empty: boolean, sorted: boolean, unsorted: boolean}
  totalElements: number
  totalPages: number
}

export class Pendencia {
  justificativa: string;
  tipoRejeicao: string;
}
